export default {
    active_sessions: "Активні сесії",
    ask_for_details_on_response: "Запитувати деталі під час відповіді",
    browser: "Браузер",
    browser_data: "Дані браузера",
    current_session: "Поточна сесія",
    delete_all_sessions_except_current: "Видалити всі сесії, крім поточної",
    delete_attachment: "Видалити вкладення",
    delete_signed: "Видалити підписаний",
    failed_login_attempts: "Невдалі спроби входу",
    finished_sessions: "Завершені сесії",
    last_use: "Останнє використання",
    login_attempt: "Спроба входу",
    operating_system: "Операційна система",
    password_expires_in_days: "Термін дії вашого пароля закінчується сьогодні | Термін дії вашого пароля закінчується через {day} день | Термін дії вашого пароля закінчується через {day} дні | Термін дії вашого пароля закінчується через {day} днів",
    password_valid_until_note: "Термін дії поточного пароля до:",
    question_for_women_only: "Питання тільки для жінок",
    reset_questionnaire_fill: "Скинути заповнення анкети",
    sessions: "Сесії",
    tell_more: "Розкажіть більше",
    wrong_password: "Невірний пароль",
    "2fa_failed": "Помилка двофакторної автентифікації"
}
